import React from "react";
import { ModeRendererProps } from "./types";

export function ConvexMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      <ellipse cx="0" cy="0" rx="310" ry="290" fill="url(#lensConvex)" />
      {Array.from({ length: 12 }).map((_, i) => {
        const r = 40 + i * 24;
        const alt = i % 3;
        const id = alt === 0 ? "hex-aqua" : alt === 1 ? "hex-violet" : "hex-amber";
        const stroke = alt === 0 ? brand.aqua : alt === 1 ? brand.violet : brand.amber;
        const k = 1 + i * 0.06;
        const op = 0.14 + (11 - i) * 0.03;
        return (
          <g key={i} opacity={Math.max(0.06, Math.min(0.85, op))}>
            <circle r={r + 12} fill="none" stroke={stroke} strokeWidth={i % 2 ? 1.2 : 0.8} opacity={0.35} />
            <defs>
              <pattern id={`hexScaled-convex-${i}`} href={`#${id}`} patternTransform={`scale(${k})`} />
            </defs>
            <circle r={r} fill={`url(#hexScaled-convex-${i})`} />
          </g>
        );
      })}
      <g>
        <circle r="34" fill={brand.deep} />
        <circle r="32" fill={brand.aqua} opacity="0.15" />
        <path d="M0 0 L32 0 A32 32 0 0 1 0 32 Z" fill={brand.violet} opacity="0.25" />
        <path d="M0 0 L0 -32 A32 32 0 0 1 32 0 Z" fill={brand.amber} opacity="0.25" />
      </g>
    </g>
  );
}
